export default __webpack_public_path__ + "static/2024浙江省科学技术进步奖公示信息表-b186c9ea48020e91945983ce71c257a5.pdf";